import { m } from "@recobra/i18n/messages";
import { TaskStatus } from "@recobra/schemas/task";

const WAITING_VALUE_SEPARATOR = ":";

/**
 * A select carries a single string value, so a parked task encodes both halves
 * of its state as `waiting:<reason>`; every other status stands alone.
 */
export const encodeTaskStatusValue = (status: TaskStatus, waitingStatus?: string | null): string =>
  status === "waiting" && waitingStatus
    ? `${status}${WAITING_VALUE_SEPARATOR}${waitingStatus}`
    : status;

export const decodeTaskStatusValue = (
  value: string | null,
): { status: TaskStatus; waitingStatus?: string } | null => {
  const [status, waitingStatus] = (value ?? "").split(WAITING_VALUE_SEPARATOR);
  const parsed = TaskStatus.safeParse(status);
  if (!parsed.success) return null;

  return waitingStatus ? { status: parsed.data, waitingStatus } : { status: parsed.data };
};

/**
 * Statuses a user may move a task to. `done` is excluded — it is reached
 * through the completion flow, which validates the task requirements.
 */
export const SELECTABLE_TASK_STATUSES: readonly TaskStatus[] = ["todo", "in_progress"];

/** A parked task reads as its reason; the column name alone would say nothing. */
export const taskStatusLabel = (status: TaskStatus, waitingStatus?: string | null): string =>
  status === "waiting" && waitingStatus
    ? m.task_waiting_status_label({ waitingStatus })
    : m.task_status_label({ status });

export const taskStatusValueLabel = (value: string | null): string => {
  const decoded = decodeTaskStatusValue(value);

  return decoded ? taskStatusLabel(decoded.status, decoded.waitingStatus) : (value ?? "");
};
